import { TranslationObject } from '../i18n/translation';

const translations: TranslationObject = {
  studiestedInfoTitle: {
    id: 'about.studiestedInfoTitle',
    nb: 'Høyskoler og universitet',
    en: 'Colleges and universities',
  },
  studiestedInfoSubtitle: {
    id: 'about.studiestedInfoSubtitle',
    nb: 'Arbeidslivsportalen forenkler planlegging av og samarbeid om studentpraksis.',
    en: 'This portal is professionalizing the cooperation between the actors involved in work placement',
  },
  studiestedInfoMainText: {
    id: 'about.studiestedInfoMainText',
    nb: '<p>Gjennom portalen organiseres praksisaktiviteter på en sikker og effektiv måte, inkludert tildeling og endring av praksisplasser. All informasjon om behov og kapasitet samles på ett sted, Portalen forenkler samhandlingen med praksisstedet</p><p>God oversikt over praksisplasser og praksissteder, gjør det enklere å følge opp studenter i praksis.</p>',
    en: "<p>It will, among other thing, make sure all information about need and capacity is gathered in one place. Good overview of one's own work places make it easier to follow up on students' work placements, and to track of agreements.</p><p>The solution makes it possible to reuse data about work placement periods from one year to the next.</p>",
  },
  infoCardCaptionLinkText: {
    id: 'about.infoCardCaptionLinkText',
    nb: 'Rettigheter og personvernerklæring',
    en: 'Rights and privacy policy',
  },
  studiestedInfoCaptionText: {
    id: 'about.studiestedInfoCaptionText',
    nb: 'som ansatt ved studiested.',
    en: 'as an employee at educational institution.',
  },
  studentInfoTitle: {
    id: 'about.studentInfoTitle',
    nb: 'Studenter',
    en: 'Students',
  },
  studentInfoSubtitle: {
    id: 'about.studentInfoSubtitle',
    nb: 'Arbeidslivsportalen gir studentene riktig praksisrelatert informasjon til riktig tidspunkt.',
    en: 'The portal gives the students the appropriate work placement related information at the right time.',
  },
  studentInfoMainText: {
    id: 'about.studentInfoMainText',
    nb: '<p>Studentene kan finne informasjon om sine praksisopphold, og de får relevant informasjon om praksisstedet til skal til. Dette bidrar til å gjøre studentene bedre forberedt til praksisoppholdet.</p><p>Arbeidslivsportalen gjør det enkelt å inkludere studentenes ønsker inn i fordelingen av praksisplasser.</p>',
    en: '<p>By conveying expectations and hva is expected of them during the work placement period, the students are better prepared for the work placement.</p><p>The students should feel that their asigned work placements are relevant, both regarding their education and personal motivations for a future work place.</p>',
  },
  studentInfoCaptionText: {
    id: 'about.studentInfoCaptionText',
    nb: 'som student i høyere utdanning.',
    en: 'as a student of higher education.',
  },
  praksisstedInfoTitle: {
    id: 'about.praksisstedInfoTitle',
    nb: 'Praksissteder',
    en: 'Work placement institutions',
  },
  praksisstedInfoSubtitle: {
    id: 'about.praksisstedInfoSubtitle',
    nb: 'Arbeidslivsportalen gir praksis-stedene en komplett oversikt over bestillinger fra alle sine samarbeidspartnere, samlet på ett sted.',
    en: 'In this portal, the work placement institutions get the necessary overview of orders from all their affiliates , in one place.',
  },
  praksisstedInfoMainText: {
    id: 'about.praksisstedInfoMainText',
    nb: '<p>Portalen gir oversikt over alle praksisplassene som er meldt inn fra din organisasjon samt hvor i organisasjonen praksisplassene finnes Dette gjør det enklere å sammenligne behov forespeilet fra utdanningsinstitusjonen opp mot hvilken kapasitet praksisstedet har.</p><p>God oversikt gir deg raskere håndtering av praksis og støtter et godt samarbeid mellom utdanning og arbeidsliv.</p>',
    en: '<p>In this solution the work placement organizations can see all work placements they have reported, and where in the organization these are found. This forms the basis for comparing with agreed capacity at work placements.</p><p>The solution supports a good relationship about work placements.</p>',
  },
  praksisstedInfoCaptionText: {
    id: 'about.praksisstedInfoCaptionText',
    nb: 'som ansatt på arbeidssted med studentpraksis.',
    en: 'as an employee at work places offering work placement.',
  },
};

export default translations;
